<template>
  <div>
    <div>
      <!-- 버튼 리스트 -->
      <v-list>
        <template>
          <draggable :list="buttons">
            <v-list-tile
              class="push-btn-basic cursor"
              :style="marketingTemplateContentBtnColor === '' ? `background-image: linear-gradient(264deg, #ceb3d8, #ffa3a3)`  : `background: ${marketingTemplateContentBtnColor};box-shadow: 0 3px 8px ${marketingTemplateContentBtnColor}`"
              v-for="(item, index) in buttons" :key="index"
              @click="buttonAction(item)"
              >
              <v-list-tile-content>
                <v-list-tile-title class="fs-16" v-html="item.name"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </draggable>
        </template>
      </v-list>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import draggable from 'vuedraggable'

export default {
  name: 'templateButton',
  components: {
    draggable
  },
  data () {
    return {
      buttons: []
    }
  },
  computed: {
    ...mapGetters([
      'currentBrandId',
      'marketingTemplateContent',
      'marketingTemplateContentBtnColor',
      'marketingTemplateContentTitle'
    ])
  },
  watch: {
    marketingTemplateContent () {
      this.buttons = this.marketingTemplateContent.content.button
    }
  },
  destroyed () {
  },
  mounted () {
    this.buttons = this.marketingTemplateContent.content.button
  },
  methods: {
    ...mapMutations([
    ]),
    buttonAction (item) {
      if (item.buttonType === 'URL_BUTTON') {
        window.open(item.url, '_blank')
      } else if (item.buttonType === 'TEL_BUTTON') {
        window.open('tel:' + item.callNumber, '_blank')
      } else {
        return false
      }
    }
  }
}
</script>

<style type="scss" scoped>
.v-list__tile{
  height: 0px !important;
}
.push-btn-basic{
  box-sizing: border-box;
  margin: 0px 20px 20px 20px;
  padding: 8px 10px;
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 6px;
  height: 50px;
  color: #fff;
}
.push-btn-basic:hover {
  opacity: .8;
}
</style>



// WEBPACK FOOTER //
// src/components/push/components/templateFragments/templateButton.vue